import { createConstants } from "../utils";

export default createConstants("ADMIN", "DRIVER", "ASSOCIATED");
